


































































import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';

//models
import { Operand, OperandType } from '@/models/configurator/question';
import { Module } from '@/models/configurator/module';

//helpers
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { isNil } from 'lodash';

export default mixins(Proxyable).extend({
  data: () => ({
    OperandType,
    operandTypes: [
      { text: 'Question', value: OperandType.VARIABLE },
      { text: 'Constant', value: OperandType.CONSTANT },
      { text: 'None', value: OperandType.NONE }
    ]
  }),

  computed: {
    modules: get<Module[]>('configuratorModule/modules'),
    questions: get<Module[]>('configuratorQuestion/questions')
  },

  methods: {
    isNil,
    ...mapActions('configuratorQuestion', ['fetchQuestions']),

    removeOperand() {
      this.$emit('removeOperand');
    },

    finishAnswering(operand: Operand) {
      this.$emit('operandUpdated', operand);
    },

    typeChanged() {
      this.internalValue.constant = null;
      this.internalValue.question = null;
    }
  }
});
